<template>
  <div class="product-center-container">
    <div>
      <div class="product-center-title">
        <span class="main-title wow fadeInUp">产品中心</span>
        <span class="sub-title wow fadeInUp">PRODUCT</span>
      </div>
    </div>
    <div class="product-center-cards-container">
      <div
        class="product-center-card-wrapper"
        @click="toProductCenter('/product/zn')"
      >
        <div class="product-center-card wow fadeInUp">
          <div class="card-body">
            <div class="logo">
              <img src="@/assets/images/zn-logo.png" alt="" />
            </div>
            <div class="title">
              <span>众诺CRM</span>
            </div>
            <div class="introduce">
              <span
                >专为妇产医院快速销售而打造的客户关系管理系统，全流程解决客户管理需求</span
              >
            </div>
          </div>

          <div class="detail-btn">
            <span>查看详情</span>
          </div>
        </div>
      </div>
      <div
        class="product-center-card-wrapper"
        @click="toProductCenter('/product/mly')"
      >
        <div class="product-center-card wow fadeInUp" data-wow-delay="0.1s">
          <div class="card-body">
            <div class="logo">
              <img src="@/assets/images/mly-logo.png" alt="" />
            </div>
            <div class="title">
              <span>玛莉亚U+</span>
            </div>
            <div class="introduce">
              <span
                >妇产医疗服务销售一体化工具，依托于大流量平台，实现引流到变现的快速转化</span
              >
            </div>
          </div>
          <div class="detail-btn">
            <span>查看详情</span>
          </div>
        </div>
      </div>
      <div class="product-center-card-wrapper">
        <div class="product-center-card wow fadeInUp" data-wow-delay="0.2s">
          <div class="card-body">
            <div class="logo">
              <img src="@/assets/images/crm-logo.png" alt="" />
            </div>
            <div class="title">
              <span>管理平台</span>
            </div>
            <div class="introduce">
              <span>小程序配套管理工具，实现平台的卡券核销以及视频直播等</span>
            </div>
          </div>
          <div class="detail-btn">
            <span>查看详情</span>
          </div>
        </div>
      </div>
      <div class="product-center-card-wrapper">
        <div
          class="product-center-card customize wow fadeInUp"
          data-wow-delay="0.3s"
        >
          <img src="@/assets/images/product-bg.png" alt="" />
          <div class="customize-btn">
            <span>定制产品</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    toProductCenter(path) {
      this.$router.push(path);
    },
  },
};
</script>

<style lang="scss" scoped>
.product-center-container {
  width: 100%;
  background: #f9fafc;
  min-height: 800px;
  position: relative;
  padding-top: 150px;
  .product-center-title {
    padding-top: 30px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    & > div {
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
    .main-title {
      font-family: PingFangSC-Semibold;
      font-size: 30px;
      color: #222222;
      text-align: center;
    }
    .sub-title {
      font-family: PingFangSC-Light;
      font-size: 24px;
      color: #c4cad6;
      text-align: center;
    }
  }
  .product-center-cards-container {
    margin-top: 50px;
    display: flex;
    justify-content: center;
    .product-center-card-wrapper {
      cursor: pointer;
      user-select: none;
      &:not(:last-child) {
        margin-right: 20px;
      }
      &:hover {
        .product-center-card {
          transform: translateY(-10px) !important;
          transition: all 0.3s;
          box-shadow: 0 2px 20px 0 rgba(47, 92, 165, 0.08);
          .detail-btn,
          .customize-btn {
            width: 188px;
            background-image: linear-gradient(270deg, #119dfd 0%, #0764fb 100%);
            border-radius: 17px;
            border: none;
            color: #ffffff;
            transition: width 0.6s;
          }
        }
      }
    }
    .product-center-card {
      width: 250px;
      height: 380px;
      padding: 40px 30px;
      background: #ffffff;
      border: 1px solid #e9eef5;
      border-radius: 2px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .card-body {
        .logo {
          img {
            height: 40px;
          }
        }
        .title {
          margin-top: 20px;
          font-family: PingFangSC-Semibold;
          font-size: 20px;
          color: #222222;
        }
        .introduce {
          margin-top: 20px;
          padding-top: 20px;
          border-top: 1px solid #eaecf2;
          font-family: PingFangSC-Regular;
          font-size: 16px;
          color: #7b8799;
          line-height: 28px;
        }
      }
      .detail-btn,
      .customize-btn {
        width: 104px;
        height: 34px;
        border: 1px solid #0764fb;
        border-radius: 17px;
        font-family: PingFangSC-Regular;
        font-size: 16px;
        color: #0764fb;
        @include btn;
      }
    }
    .customize {
      // width: 250px;
      position: relative;
      padding: 0;
      img {
        // position: absolute;
        width: 100%;
      }
      .customize-btn {
        position: absolute;
        bottom: 40px;
        left: 30px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/home/components/productCenter.vue